import { render } from "./WheelAndMatrix.vue?vue&type=template&id=1c438306&ts=true&lang=pug"
import script from "./WheelAndMatrix.vue?vue&type=script&lang=ts"
export * from "./WheelAndMatrix.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__